//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    number:{
      type: Number,
      required: true
    }
  },
  data(){
    return{
      active: false
    }
  },
  mounted() {
    window.addEventListener("resize", this.resizeAllActiveAnswers);
  },
  beforeDestroy () {
    window.removeEventListener("resize", this.resizeAllActiveAnswers);
  },
  methods:{
    toggleActive(e){
      this.active = !this.active;
      this.setAnswerHeight(e.currentTarget.parentNode)
    },
    setAnswerHeight(parent){
      const answer = parent.querySelector('.faq-category-list-item-answer')
      const answerInner = answer.querySelector('.faq-category-list-item-answer-inner')
      answer.style.height = this.active ? answerInner.offsetHeight + 'px' : '0px'
    },
    resizeAllActiveAnswers(){
      this.active ? this.setAnswerHeight(this.$el) : null
    }
  },

}
